import { QueryClientProvider } from '@tanstack/react-query'
import { createRootRoute, Outlet } from '@tanstack/react-router'
import {
  AnalyticsErrorBoundary,
  PostHogProvider,
  useIdentify,
  usePageTracking,
} from '@turfchale/analytics'
import { useAuthStore } from '@turfchale/supabase'
import { Toaster } from 'react-hot-toast'

import { queryClient } from '@/lib/queryClient'

export const Route = createRootRoute({
  beforeLoad: async () => {
    await useAuthStore.getState().initialize()
  },
  component: RootLayout,
  pendingComponent: () => <div className="tc-route-loader" />,
})

function RootLayout() {
  useIdentify()
  usePageTracking()

  return (
    <PostHogProvider>
      <AnalyticsErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <Outlet />
          <Toaster
            position="bottom-left"
            toastOptions={{
              style: {
                background: '#162b1c',
                border: '1px solid rgba(184,236,60,0.18)',
                borderRadius: '10px',
                color: '#eef4ee',
                fontSize: '14px',
              },
            }}
          />
        </QueryClientProvider>
      </AnalyticsErrorBoundary>
    </PostHogProvider>
  )
}
